import { useEffect, useState } from 'react';
import Script from 'next/script';
import styles from './evesReviews.module.scss';

const EvesReviews = ({ eanNumber, locale, title }) => {
  const [waeData, setWaeData] = useState({});

  const waeSettings = {
    target: '#wae-sdk',
    ratingTargets: ['.wae-rating'],
    viewType: 'REVIEW',
    productIdType: 'BARCODE',
    productId: eanNumber,
    brandId: process.env.NEXT_PUBLIC_WAE_BRAND_ID,
    API_KEY: process.env.NEXT_PUBLIC_WAE_API_KEY,
    language: locale,
    country: 'nl',
    pageSize: 5,
    theme: 'light',
    isSortOn: true,
  };

  const fetchWaeGeneralData = async () => {
    setWaeData({});
    try {
      const request = await fetch(
        `https://api.weareeves.com/embed/v2/productReviews?${new URLSearchParams({
          brandId: waeSettings.brandId,
          API_KEY: waeSettings.API_KEY,
          embedId: waeSettings.productId,
          idType: waeSettings.productIdType,
          country: waeSettings.country,
          language: waeSettings.language,
          pageSize: 0,
        })}`
      );

      if (request.ok) {
        const data = await request.json();
        setWaeData(data);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    document.querySelector(`${waeSettings.ratingTargets[0]}`).innerHTML = '';
    const isProd = window.location.hostname === process.env.NEXT_PUBLIC_SITE_HOSTNAME;

    if (isProd) {
      fetchWaeGeneralData();
    }
  }, [eanNumber, locale]);

  return (
    <section className={styles.container}>
      {waeData.totalCount > 0 && (
        <>
          <h2 className={styles.title}>{title}</h2>
          <div className={styles.divider} />
          <div id="wae-sdk" style={{ width: '100%' }} />
          <Script type="text/javascript">{`
            new WAE_SDK(${JSON.stringify(waeSettings)});
          `}</Script>
        </>
      )}
    </section>
  );
};

export default EvesReviews;
